module.exports = __webpack_public_path__ + "img/bg01.b4f72193.jpg";